import React from "react";
import { connect } from "react-redux";
import { useState, useEffect } from "react";
import { NavLink, useHistory } from "react-router-dom";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import LayoutTopSideBottom from "../layouts/LayoutTopSideBottom/LayoutTopSideBottom";

import { updateAlert, updateSourceInputs } from "../redux/actions";
import sidenavData from "../../assets/data/sidenavData.json";
import { Grid } from "@material-ui/core";
import { splitUrlToBreadcrumbData } from "../utils/utils";

const HomePage = (props) => {
  const { match, user, user_detail, updateAlert, updateSourceInputs } = props;
  const [user_restriction, setuser_restriction] = React.useState([]);
  let history = useHistory();
  const data = splitUrlToBreadcrumbData(match.url);

  const clearReduxState = () => {
    updateSourceInputs("has_awaiting_data", false);
    updateSourceInputs("data", []);
    updateSourceInputs("checked_rows_count", 0);
    updateSourceInputs("current_bussines_unit", "");
    updateSourceInputs("current_dimension", {});
    updateSourceInputs("dimensions_list", []);
    updateSourceInputs("current_source", "");
    updateSourceInputs("current_source_label", "");
    updateSourceInputs("current_target_gold_layer", "");
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_cmu", "");
    updateSourceInputs("current_category", "");
    updateSourceInputs("current_ssfFileId", "");
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_template_filter_value", "");
    updateSourceInputs("current_template_ssfFileId", "");
    updateSourceInputs("current_table_name", "");
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("isFileUploaded", false);
    updateSourceInputs("isNewDataInserted", false);
    updateSourceInputs("current_bussines_unit_list", []);
    updateSourceInputs("current_mapped_source", []);
    updateSourceInputs("current_target_gold_layer_list", []);
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("master_table_countries", []);
    updateSourceInputs("current_ssf_file_id", []);
    updateSourceInputs("current_template_ssf_file_id", []);
    updateSourceInputs("current_category_data", []);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_mapped_data_main", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("current_filters", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("download_sample_file", []);
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("current_columns", []);
    updateSourceInputs("actualData", []);
    updateSourceInputs("recommendedModel", []);
    updateSourceInputs("approvalData", []);
    updateSourceInputs("approvalTable_Header", []);
  };

  const handleNavClick = (e, path) => {
    e.preventDefault(); // ⛔ stop default <NavLink> navigation
    clearReduxState();

    const CURRENT_USECASE_DETAILS =
      user_detail?.user_info?.allowed_sidenav?.find(
        (item) => item.id === path,
      ) ?? {};
    updateSourceInputs(
      "current_usecase_value",
      CURRENT_USECASE_DETAILS?.value || path.split("/").pop(),
    );
    history.push(`/${path}`);
  };

  function getUserRestriction() {
    if (
      user_detail &&
      user_detail.user_info &&
      Array.isArray(user_detail.user_info.allowed_sidenav) &&
      user_detail.user_info.allowed_sidenav.length > 0
    ) {
      const Sorted_SideNav_Data = user_detail?.user_info?.allowed_sidenav?.map(
        (item) => {
          if (item.is_sidenav && !Array.isArray(item?.sidenav_details)) {
            const Side_Nav_Category =
              item?.sidenav_details?.sidebar_details || [];
            const Usecases = item?.sidenav_details?.usecases || [];

            let FirstUseCaseDetails = {};
            Side_Nav_Category?.forEach((sdItem) => {
              if (
                FirstUseCaseDetails &&
                !Object.keys(FirstUseCaseDetails).length > 0 &&
                Usecases?.[sdItem.value].length > 0
              ) {
                FirstUseCaseDetails = Usecases?.[sdItem.value]?.[0] || {};
                return;
              }
            });

            const SORTED_FIRST_USE_CASE_DETAILS = {
              id: `harbor/local_reporting/${FirstUseCaseDetails?.value || ""}`,
              name: "Local Reporting",
              materialUiIconName: FirstUseCaseDetails.materialUiIconName,
              materialUiClassName: "material-icons-outlined",
              specialStyling: false,
              component: FirstUseCaseDetails.component,
              app_name: "Harbor",
              is_sidenav: false,
              sidenav_details: {},
            };

            return SORTED_FIRST_USE_CASE_DETAILS;
          }
          if (item.is_sidenav && Array.isArray(item?.sidenav_details)) {
            const AdminSubRoutesList = item?.sidenav_details || [];
            const FirstUseCaseDetails = AdminSubRoutesList?.[0] || {};

            return {
              id: `harbor/${item?.value || "admin_controls"}/${FirstUseCaseDetails.value}`,
              name: item.name,
              materialUiIconName: item.materialUiIconName,
              materialUiClassName: "material-icons-outlined",
              specialStyling: false,
              component: FirstUseCaseDetails.component,
              app_name: "Harbor",
              is_sidenav: false,
              sidenav_details: {},
            };
          }
          return item;
        },
      );
      setuser_restriction(Sorted_SideNav_Data);
    } else {
      setuser_restriction([]); // fallback to empty array
    }
    // window.location.href("https://app-trinity-dev-roci-northeurope.azurewebsites.net/");
  }

  useEffect(() => {
    const info = user_detail.user_info;
    if (
      info &&
      Object.keys(info).length > 0 &&
      info.allowed_sidenav &&
      info.allowed_sidenav.length > 0
    ) {
      getUserRestriction();
    } else {
      const Sorted_SideNav_Data = sidenavData?.map((item) => {
        if (item.is_sidenav) {
          const Side_Nav_Category =
            item?.sidenav_details?.sidebar_details || [];
          const Usecases = item?.sidenav_details?.usecases || [];

          let FirstUseCaseDetails = {};
          Side_Nav_Category?.forEach((sdItem) => {
            if (
              FirstUseCaseDetails &&
              !Object.keys(FirstUseCaseDetails).length > 0 &&
              Usecases?.[sdItem.value].length > 0
            ) {
              FirstUseCaseDetails = Usecases?.[sdItem.value]?.[0] || {};
              return;
            }
          });

          const SORTED_FIRST_USE_CASE_DETAILS = {
            id: `harbor/local_reporting/${FirstUseCaseDetails?.value || ""}`,
            name: "Local Reporting",
            materialUiIconName: FirstUseCaseDetails.materialUiIconName,
            materialUiClassName: "material-icons-outlined",
            specialStyling: false,
            component: FirstUseCaseDetails.component,
            app_name: "Harbor",
            is_sidenav: false,
            sidenav_details: {},
          };

          return SORTED_FIRST_USE_CASE_DETAILS;
        }
        return item;
      });
      // setuser_restriction(Sorted_SideNav_Data);
      setuser_restriction([]);
    }
  }, [user_detail, user_detail.user_info]);

  return (
    <>
      <LayoutTopSideBottom match={props.match}>
        {user_restriction && user_restriction.length > 1 && (
          <Breadcrumbs match={props.match} />
        )}
        {user_restriction && user_restriction.length > 0 ? (
          <Grid container spacing={4} style={{ padding: "20px 15px 0px 15px" }}>
            {user_restriction.map((tail) => (
              <Grid item xs={3} sm={3}>
                <NavLink
                  to={`${tail.id.replace(/^harbor\//, "")}`}
                  onClick={(e) => handleNavClick(e, tail.id)}
                  style={{ textDecoration: "none" }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 4px 20px rgba(235, 54, 127, 0.2)",
                      padding: "25px 10px",
                      borderRadius: "10px",
                    }}
                  >
                    <span
                      className="material-symbols-outlined"
                      style={{
                        fontSize: "50px",
                        color: "#eb367f",
                        marginBottom: "16px",
                        textDecoration: "none",
                      }}
                    >
                      {tail.materialUiIconName}
                    </span>
                    <p
                      style={{
                        fontSize: "18px",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      {tail.name}
                    </p>
                  </div>
                </NavLink>
              </Grid>
            ))}
          </Grid>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "60vh",
            }}
          >
            <span
              className="material-symbols-outlined"
              style={{
                fontSize: "50px",
                color: "#eb367f",
                marginBottom: "16px",
              }}
            >
              block
            </span>
            <p
              style={{
                fontSize: "18px",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              No screens found for your account. Please contact the
              administrator.
            </p>
          </div>
        )}
      </LayoutTopSideBottom>
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
  user_detail: state.user_detail,
});

const mapDispatchToProps = {
  updateAlert,
  updateSourceInputs,
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
